export default __webpack_public_path__ + "static/media/natura2.2a60e811.svg";